import React, { useState, useEffect, Suspense } from "react";
import { Tabs, Button, Space, Drawer, Spin } from "antd";
import { DownloadOutlined, UserAddOutlined, FilterOutlined } from '@ant-design/icons';
import { useEngagementStore } from "./store";
import Qaauditfilter from "./Qaauditfilter";
import { downloadQaAuditData } from "./api/api";
import dayjs from "dayjs";
import moment from "moment";
import secureLocalStorage from "react-secure-storage";
import { getCurrentUserRole, ROLES_NAME } from "modules/utilities/utility";

const { TabPane } = Tabs;

// Lazy load components
const QaScoringTable = React.lazy(() => import('./QaScoringTable'));
const ChartComponent = React.lazy(() => import('./ChartComponent'));

const MainContent = () => {
  const {
    qaScoringFeedbackData,
    chartAuditData,
    chartAuditLoading,
    fetchChartAuditData,
    assignAgentsToQaFunc,
    fetchAllAgentAndQaData,
  } = useEngagementStore();

  const [activeTabKey, setActiveTabKey] = useState("1");
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [queryParams, setQueryParams] = useState({});

  // Fetch initial data only for AllAgentAndQaData
  useEffect(() => {
    fetchAllAgentAndQaData(); // Fetch data for AllAgentAndQaData when the component is first rendered
  }, []); // Empty dependency array ensures this runs only on the first render

  const handleDownload = async () => {
    const response = await downloadQaAuditData({ auditedDate : `[${moment().format('YYYY-MM-DD')},${moment().format('YYYY-MM-DD')}]`, ...queryParams });
    const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', 'Audited_Engagement.csv');
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleAssign = async () => {
    await assignAgentsToQaFunc();
  };

  const handleTabChange = (key) => {
    setActiveTabKey(key);
    if (key === "2") { 
      fetchChartAuditData(queryParams); // Always fetch chart data when switching to the Chart tab
    }
  };

  const toggleDrawer = () => {
    setDrawerVisible(!drawerVisible);
  };

  const handleApplyFilters = (filters) => {
    setQueryParams(filters);
    if (activeTabKey === "1") {
      fetchAllAgentAndQaData(filters); // Fetch data for QaScoringTable if the first tab is active
    } else if (activeTabKey === "2") {
      fetchChartAuditData(filters); // Fetch data for ChartComponent if the second tab is active
    }
  };

  const allowedEmailsDownloadButton = ["sejalsawant@traya.health", "suyash@traya.health", "anjumshaikh@traya.health", "rajeshyadav@traya.health"];
  
  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Tabs defaultActiveKey="1" onChange={handleTabChange}>
          <TabPane tab="Table" key="1" />
          {/* <TabPane tab="Chart" key="2" /> */}
        </Tabs>
        <Space>
          {qaScoringFeedbackData?.isQaAssignButtonEnabled && (
            <Button icon={<UserAddOutlined />} onClick={handleAssign}>
              Assign
            </Button>
          )}
         {(allowedEmailsDownloadButton.includes(secureLocalStorage.getItem('email')) || ROLES_NAME.TEAM_LEAD.includes(getCurrentUserRole())) && (
            <Button icon={<DownloadOutlined />} onClick={handleDownload}>
              Download
            </Button>
          )}
          <Button icon={<FilterOutlined />} onClick={toggleDrawer}>
            Filter
          </Button>
        </Space>
      </div>
      <div>
        <Suspense fallback={<Spin tip="Loading..." />}>
          {activeTabKey === "1" && <QaScoringTable queryParams={queryParams} totalCountData={qaScoringFeedbackData?.totalCount} />}
          {activeTabKey === "2" && <ChartComponent chartData={chartAuditData} loading={chartAuditLoading} />}
        </Suspense>
      </div>
      <Drawer
        title="Filter for QA Audit"
        placement="right"
        onClose={toggleDrawer}
        visible={drawerVisible}
        width="30%"
        zIndex={999999999}
      >
        <Qaauditfilter
          visible={drawerVisible}
          onClose={toggleDrawer}
          onApplyFilters={handleApplyFilters}
        />
      </Drawer>
    </div>
  );
};

export default MainContent;
